require('./bootstrap');

//----------------------------------------------------
// app requirements
//----------------------------------------------------
global.moment = require('moment');
import 'moment';

require('tempusdominus-bootstrap-4');
require('@fancyapps/fancybox');
require('inputmask');

// $.fancybox.defaults.modal = true;
$.fancybox.defaults.smallBtn = true;
$.fancybox.defaults.touch = false;
$.fancybox.defaults.clickContent = function(){ return false; };
// $.fancybox.defaults.clickSlide = function(){ alert('oi')};
// $.fancybox.defaults.clickOutside = function(){ alert('ja')};

var dt = require( 'datatables.net' );

var select2 = require('./select2.full.js');
var tableSort = require('../vendor/sortable/sortable.js');

// require('orgchart');

$(document).ready(function(){

	if($('.js-selected-styled').length){
		$('.js-selected-styled').select2({
			width: '100%'
		});
	}


	// if($('#family_tree').length){
	// 	$('#family_tree').orgchart({
	// 		'data' : $('#ul-data')
	// 	});
	// }

});